import { render, staticRenderFns } from "./UsuariosListagem.vue?vue&type=template&id=20caf5cc&scoped=true"
import script from "./UsuariosListagem.vue?vue&type=script&lang=js"
export * from "./UsuariosListagem.vue?vue&type=script&lang=js"
import style0 from "./UsuariosListagem.vue?vue&type=style&index=0&id=20caf5cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20caf5cc",
  null
  
)

export default component.exports